import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, frames } from '../../../Styles';
import { PageHeader, ProgressBar } from '../../../Components';
import { Pages } from '../../../Navigation/root';
import { useAppSelector } from '../../../Store';
import { Graph_QL, useAnimal } from '../../../Services';
import { cloneDeep } from 'lodash';
import { useMultipleConsumptions } from '../../../Components/_Components/consumption';

export default function Dashboard() {
  const { t } = useTranslation();

  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const domain = useMemo(() => Graph_QL.ObjToString({ domain: farm }), [farm]);
  const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);

  const { call: getAnimalsInfo, data: animalsState, maintainEntries: updateAnimals } = useAnimal(connection);

  const [animals, setAnimals] = useState(animalsState && animalsState[domain] ? cloneDeep(animalsState[domain].data) : []);
  
  const consumptionData = useMultipleConsumptions([77, 76]);
  
  let TodayCons = consumptionData[0]

  return (
    <frames.Page_inner>
      <PageHeader topHeader={t(`menuHeaders.${Pages.dashboard}`, {defaultValue: "dashboard"})} subHeader={t("menuHeaders.overview", {defaultValue: "overview"})} />
      <frames._page_inner_content_scroll style={{backgroundColor: colors.greyLightTertiary, padding: "20px"}}>

        
      </frames._page_inner_content_scroll>
    </frames.Page_inner>
  );
}